<template>
  <div v-if="filters.selectedAirlines.length > 0">
    <div class="" style="border: 10px solid #E6E6E6;"></div>

    <div
      v-if="flightSearchLoadingStatus == false"
      class="is-flex is-justify-content-center pl-2 pr-2"
    >
      <div
        class="mt-1 mb-2 is-centered"
        :class="pathMixin_isMeeting ? 'box' : ''"
      >
        <div class="is-size-6 mb-4 is-centered" style="text-align: center">
          Looking for more flight options? <br />Search for more specific
          flights on these airlines:
        </div>

        <FlightFilters
          v-model="filters"
          :filterOptions="filterOptions"
          :highlights="highlightedFilters"
          :sortOptions="[]"
          :unusedTickets="[]"
          :tripVal="filterOptions.tripVal"
          @clearFilters="$emit('clearFilters')"
          @resetFilter="$emit('resetFilter')"
        />

        <div class="mt-4 is-flex is-justify-content-center">
          <div
            class="button is-rounded is-primary "
            @click="startSearch(filters.selectedAirlines)"
          >
            Search for matching flights
            <span class="icon is-right ml-4"
              ><i class="mdi mdi-airplane-takeoff mdi-24px"></i
            ></span>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-1 pb-2 pr-0" v-if="flightSearchLoadingStatus === true">
      <div class="has-text-centered p-6">
        <span class="gant-text"
          >Please wait while we're searching for additional flights.
        </span>
        <ReloadIcon style="width: 30px;" />
      </div>
    </div>
  </div>
</template>

<script>
import ReloadIcon from "/public/images/SVGs/Reload-1s-200px.svg";
import FlightFilters from "@/components/Filters/FlightFilters.vue";
export default {
name: "MoreFlightResultsLoader",
mixins: [],
props: {
  filters: Object,
  filterOptions: Object,
  //distinctAirlines: Array,
  highlightedFilters: Object,
},
components: {
  ReloadIcon,
  FlightFilters
},
data: function() {
  return {};
},
methods: {
  startSearch(filteredAirlines) {

    this.$store.commit("bookTravel/FLIGHT_SEARCH_LOADING_STATUS", true);

    //reduce array of objects to simple array of airline codes
    let targetedAirlines = filteredAirlines.map((a) => a.code);    

    this.$emit("searchTargetedAirlines", targetedAirlines);
  },
},
computed: {
  flightSearchLoadingStatus(){
    return this.$store.state.bookTravel.flightSearchLoadingStatus;
  }, 
  selectedAirlines(){
    let selected = this.filters.selectedAirlines;
    return selected;
    //TO DO: Filter out 'Multiple Airlines'
    //return selected.filter( (airlines) => { return airlines.code != '??'} );

  }
}
};
</script>

<style></style>
